import { render, staticRenderFns } from "./Grayscale.vue?vue&type=template&id=516b7bbb&scoped=true&"
import script from "./Grayscale.vue?vue&type=script&lang=ts&"
export * from "./Grayscale.vue?vue&type=script&lang=ts&"
import style0 from "./Grayscale.vue?vue&type=style&index=0&id=516b7bbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516b7bbb",
  null
  
)

export default component.exports